import { H3, P } from "../../../../AbstractElements";
import { OVER_RATING_STAR } from "../../../../Data/Dashboard";

export const OverAllRatingBox = () => {
const OverAllRatingData: number[] = [1, 2, 3, 4, 5];

  return (
    <div className="rating-box">
      {OVER_RATING_STAR.map((item, index) => (
        <div className="d-flex gap-2" key={index}>
          <div className="flex-shrink-0">
            <H3>{item.rate}</H3>
          </div>
          <div className="flex-grow-1">
            <span className="d-flex">
              {OverAllRatingData.map((index) => (
                <i className="fa fa-star font-warning" key={index}></i>
              ))}
            </span>
          </div>
          <P>{item.percentage}</P>
        </div>
      ))}
    </div>
  );
};
